import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/image';
import { Device, from, until } from '@helpers/media';
import { h4, paragraphMedium, paragraphSmall } from '@helpers/typography';
import CtaLinkStyles from '@stories/Components/Buttons/CtaLink/CtaLink.styles';
import Image from '@stories/Components/Misc/Image/Image';
import styled from 'styled-components';
const Container = styled.button `
  ${ButtonReset};
  --shadowColour: rgba(0, 0, 0, 0.03);

  box-shadow: -0.1px -1.1px 1.1px var(--shadowColour), -0.2px 2.7px 3px -0.8px var(--shadowColour),
    -0.4px 6.3px 7.1px -1.7px var(--shadowColour), -0.9px 5px 16.9px -1px var(--shadowColour);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
  text-align: left;

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
  }

  /* Mobile click styles - button should mimic press */
  @media ${until(Device.TabletLarge)} {
    ${transition('transform')};

    &:active {
      transform: translateY(1.5px);
    }
  }

  @media ${from(Device.Tablet)} {
    box-shadow: none;
    border-radius: 10px 10px 0 0;
  }
`;
const HighlightedTag = styled.span `
  ${fonts.apparat.light};

  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  color: ${brand.white};
  background-color: ${brand.primary.orange};
  font-size: 14px;
  line-height: 1;
  text-transform: uppercase;
  padding: 8px ${fluid(10, 16)};
  border-radius: 5px 0 5px 0;
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(428, 278)};

  margin: 0;
  width: 100%;

  @media ${from(Device.Tablet)} {
    margin-bottom: 16px;
    border-radius: 0 0 10px 10px;
  }
`;
const Img = styled(Image) `
  ${transition('transform')};
  ${imageCoverContainer()};

  ${Container}.focus-ring &,
  ${Container}:hover & {
    transform: scale(1.05);
  }
`;
const ContentWrapper = styled.div `
  padding: 20px 12px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${brand.base.blue};

  @media ${from(Device.Tablet)} {
    padding: 0;
  }

  ${CtaLinkStyles.Container} {
    font-size: ${fluid(16, 20)};
    line-height: ${fluid(22, 26)};
    margin: auto 0 0;
  }
`;
const Name = styled.h3 `
  ${paragraphMedium};
  ${fonts.apparat.semiBold};

  margin: 0 0 ${fluid(14, 16)};
`;
const Role = styled.p `
  ${paragraphSmall};

  margin: 0 0 ${fluid(20, 24)};
`;
const BioWrapper = styled.div `
  display: grid;
  gap: ${fluid(35, 90)};
  color: ${brand.base.blue};
  width: 100%;

  ${ImageWrapper} {
    margin: 0;
    border-radius: 10px;
  }

  ${Role} {
    margin-bottom: 30px;

    @media ${from(Device.TabletLarge)} {
      margin-bottom: 20px;
    }
  }

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: min(40%, 428px) auto;
  }
`;
const BioTitle = styled.span `
  ${h4};

  margin: 0 0 ${fluid(10, 15)};
  color: ${brand.primary.orange};

  @media ${from(Device.TabletLarge)} {
    ${fonts.apparat.medium};
  }
`;
const Biography = styled.p `
  ${fonts.apparat.light};

  font-size: ${fluid(18, 20)};
  line-height: ${fluid(28, 30)};
`;
const PeopleCardStyles = {
    Container,
    HighlightedTag,
    ImageWrapper,
    Img,
    ContentWrapper,
    Name,
    Role,
    BioWrapper,
    BioTitle,
    Biography,
};
export default PeopleCardStyles;
